import React, { useState } from "react";
import "./CloudmanageModern.css";
import img1 from '../cloudmanageassets/imgg1.png';
import img2 from '../cloudmanageassets/imgg2.png';
import img3 from '../cloudmanageassets/imgg3.png';
import img4 from '../cloudmanageassets/imgg4.png';
import img5 from '../cloudmanageassets/imgg5.png';
import img6 from '../cloudmanageassets/imgg6.png';
import img7 from '../cloudmanageassets/imgg7.png';
import img8 from '../cloudmanageassets/imgg8.png';
import img9 from '../cloudmanageassets/imgg9.png';

export default function CloudmanageModern() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const cards = [
    {
      id: 1,
      img:img1,
      title: "AI Driven Managed Services",
      description:
        "Benefit from our always-on cloud expertise and dedicated support",
    },
    {
      id: 2,
      img:img2,
      title: "Enhanced Efficiency",
      description:
        "Streamline your cloud operations and focus on core business objectives.",
    },
    {
      id: 3,
      img:img3,
      title: "Cost Optimization",
      description:
        "Reduce your cloud spend by up to 30% through expert optimization",
    },
    {
      id: 4,
      img:img4,
      title: "Improved Uptime",
      description:
        "Achieve 99.9% guaranteed uptime for uninterrupted business continuity.",
    },
    {
      id: 5,
      img:img5,
      title: "Reduced Infrastructure Expenses",
      description:
        "Lower your infrastructure costs by up to 3x.",
    },
    {
      id: 6,
      img:img6,
      title: "Faster Migration",
      description:
        "Accelerate your digital transformation with smooth, secure, and efficient cloud migration tailored to your business.",
    },
    {
      id: 7,
      img:img7,
      title: "Strong Security & Compliance",
      description:
        "protect workloads with enterprise-grade security, continuous patching, identity, management, and compliance controls.",
    },
    {
      id: 8,
      img:img8,
      title: "24/7 Support & SLA-Driven Operations",
      description:
        "Round-the-clock support with clear SLAs for predictable performance and quick issue resolution.",
    },
    {
      id: 9,
      img:img9,
      title: "Scalability on Demand",
      description:
        "Instantly scale applications, storage, and compute resources as business needs grow without downtime.",
    },
  ];

  return (
    <div id="manage-modern" className="outsourcemainclass">
      <h2 className="heading">NFT Development Services</h2>
      <p className="subheading">
        Helping Enterprises Build an NFT Marketplace to Facilitate Minting,
        Buying, and Selling of Digital Collectibles
      </p>

      <div className="cards">
        {cards.map((card) => (
          <div className="card" key={card.id}>
            <img src={card.img} alt="error" />
            <h3>{card.title}</h3>
            <span>{card.description}</span>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {cards.map((card) => (
              <div
                className="carousel-card"
                key={card.id}
              >
                 <img src={card.img} alt="error" />
                <h3>{card.title}</h3>
                <span>{card.description}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="carousel-dots">
        {cards.map((_, index) => (
          <button
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}
